<template>
  <div class="row">
    <div class="col-md-3 mb-2">
      <select
        class="form-control"
        v-model="meta.per_page"
        @change="loadPerPage"
      >
        <option value="5">
          Tampilkan tiap 5 data
        </option>
        <option value="10">
          Tampilkan tiap 10 data
        </option>
        <option value="25">
          Tampilkan tiap 25 data
        </option>
        <option value="50">
          Tampilkan tiap 50 data
        </option>
        <option value="100">
          Tampilkan tiap 100 data
        </option>
      </select>
    </div>
      
    <div class="col-md-3 offset-md-6">
      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          @input="search"
          placeholder="Cari berdasarkan Nama Penduduk/NIK"
        >
        <div class="input-group-append">
          <button
            class="btn btn-primary"
            type="button"
          >
            <i class="fa fa-search" />
          </button>
        </div>
      </div>
    </div>
      
    <div class="col-md-12">
      <div class="table-responsive">
        <b-table
          striped
          hover
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          show-empty
        >
          <template v-slot:cell(no)="row">
            {{ (meta.per_page * (meta.current_page-1)) + row.index + 1 }}
          </template>

          <template v-slot:cell(desa)="row">
            {{ (row.item.desa) ? row.item.desa.nama_desa : '-' }}, {{ (row.item.desa) ? (row.item.desa.kecamatan) ? row.item.desa.kecamatan.nama_kecamatan : '' : '' }}
          </template>

          <template v-slot:cell(terdaftar)="row">
            <span
              v-if="row.item.user"
              class="badge badge-primary"
            ><i class="fa fa-check mr-2" />Terdaftar</span>
            <span
              v-else
              class="badge badge-danger"
            ><i class="fa fa-check mr-2" />Belum Terdaftar</span>
            <span
              v-if="row.item.is_non_permanen"
              class="badge badge-dark mt-1"
            >Non Permanen</span>
          </template>


          <template v-slot:cell(actions)="row">
            <button
              v-b-tooltip
              class="btn btn-primary btn-sm"
              title="Edit Penduduk"
              @click="$emit('editPenduduk', row.item)"
            >
              <i class="fas fa-pencil-alt" />
            </button>
            <button
              v-b-tooltip
              class="btn btn-danger btn-sm"
              title="Disable Penduduk"
              @click="$emit('hapusPenduduk', row.item)"
            >
              <i class="fa fa-trash" />
            </button>
          </template>
        </b-table>
      </div>
      <div
        class="overlay-table-loader"
        v-if="loading"
      >
        <div class="spinner" />
      </div>
    </div>
      
    <div class="col-md-6">
      <p>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items</p>
    </div>
      
    <div class="col-md-6">
      <b-pagination
        v-model="meta.current_page"
        :total-rows="meta.total"
        :per-page="meta.per_page"
        align="right"
        @change="changePage"
        aria-controls="dw-datatable"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    editUrl: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      sortBy: null,
      sortDesc: false,
      deleteModal: false,
      selected: null
    }
  },
  watch: {
    sortBy(val) {
      this.$emit('sort', {
        sortBy: this.sortBy,
        sortDesc: this.sortDesc
      })
    },
    sortDesc(val) {
      this.$emit('sort', {
        sortBy: this.sortBy,
        sortDesc: this.sortDesc
      })
    }
  },
  methods: {
    loadPerPage(val) {
      this.$emit('per_page', this.meta.per_page)
    },
    changePage(val) {
      this.$emit('pagination', val)
    },
    search: _.debounce(function (e) {
      this.$emit('search', e.target.value)
    }, 500),
    openDeleteModal(row) {
      this.deleteModal = true
      this.selected = row.item
    },
    deleteModalButton() {
      this.$emit('delete', this.selected)
      this.deleteModal = false
    }
  }
}
</script>